import { createRouter, createWebHistory } from 'vue-router';

export const appRoutes = {
  mainPage: {
    path: '/',
    name: 'main',
  },
};

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: appRoutes.mainPage.path,
      name: appRoutes.mainPage.name,
      component: () => import('../views/MainPage.vue'),
    },
  ],
});

export default router;
